import { Course, LearningProgram, JobAid, Certification } from '../';
import type {
  IModuleData,
  IInstance,
  IInstanceData,
  IEnrollmentData,
  IALMResourceData,
  IALMResource,
  ICourse
} from '../';

export interface ILearningObjectData {
  id?: string;
  parentId?: string;
  name: string;
  image: string;
  duration: number;
  dateCreated: string;
  enrollmentType: LearningObjectEnrollmentTypes;
  description: string;
  type: LearningObjectTypes;
  isExternal: boolean;
  isOrdered: boolean;
  unenrollmentAllowed: boolean;
  file: string;
  state: LearningObjectStates;
  modules?: IModuleData[];
  courses?: ILearningObjectData[];
  instance?: IInstanceData;
  instances?: IInstanceData[];
  enrollment?: IEnrollmentData;
  resources?: IALMResourceData[];
  tags?: string[];
}

export interface ILearningObject extends ILearningObjectData {
  saved: boolean;
  numId?: number;
  activeInstances: IInstance[];
  instances?: IInstance[];
  activeInstance?: IInstance;
  hasMultipleInstances: boolean;
  defaultInstance?: IInstance;
  isInstanceSelectable: boolean;
  isEnrollable: boolean;
  isActive: boolean;
  isEnrolled: boolean;
  // isUnenrollable: boolean;
  isStarted: boolean;
  isPending: boolean;
  isCompleted: boolean;
  // isUploadable: boolean;
  deadline?: string;
  deadlineDate?: Date;
  deadlineDays?: string;
  isDeadlinePassed: boolean;
  hasPassed: boolean;
  activeCourseId?: string;
  resources?: IALMResource[];
  inactiveCourses: ICourse[];
  validate(): void;
  validateBeforeEnroll(): void;
}

export enum LearningObjectTypes {
  Course = 'course',
  LearningProgram = 'learningProgram',
  JobAid = 'jobAid',
  Certification = 'certification'
}

export enum LearningObjectStates {
  Expired = 'Expired',
  Retired = 'Retired',
  Published = 'Published'
}

export enum LearningObjectEnrollmentTypes {
  AdminEnroll = 'adminEnroll',
  SelfEnroll = 'selfEnroll',
  ManagerApproval = 'managerApproval',
  ManagerNominated = 'managerNominated',
  AdminNominated = 'adminNominated'
}

export const LearningObjectGuards = {
  isCourse: (item: ILearningObject): item is Course => item.type == LearningObjectTypes.Course,
  isLearningProgram: (item: ILearningObject): item is LearningProgram =>
    item.type == LearningObjectTypes.LearningProgram,
  isJobAid: (item: ILearningObject): item is JobAid => item.type == LearningObjectTypes.JobAid,
  isCertification: (item: ILearningObject): item is Certification => item.type == LearningObjectTypes.Certification
};
